module.exports = __webpack_public_path__ + "img/9.af8b14af.jpg";